import getQueryString from "@toolkit/Framework/Common/Utilities/getQueryString";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { ParametersOmitFirst } from "@toolkit/Framework/Types/Common";

const useQueryString = <T>(...args: ParametersOmitFirst<typeof getQueryString>) => {
    const location = useLocation();

    return getQueryString<T>(location.search, ...args);
};

export default useQueryString;
